import { falCommentLines } from 'shared/@generated/icons/falCommentLines';
import { useRoute } from 'shared/library/routes/route';
import React from 'react';
import { Breeder } from 'shared/@types';
import { useTranslation } from 'react-i18next';
import { Button } from 'shared/components/button';
import { useUserStore } from 'shared/state/user';
import { useRouter } from 'shared/library/use-router';
import { analytics } from 'shared/library/analytics';

interface ContactBreederButtonProps {
  breeder: Breeder;
  text?: string;
  buttonClassName?: string;
  textClassName?: string;
}

const ContactBreederButton = ({
  breeder,
  text,
  buttonClassName,
  textClassName,
}: ContactBreederButtonProps) => {
  const { t } = useTranslation('components');
  const router = useRouter();
  const route = useRoute();
  const user = useUserStore((state) => state.user);

  function onPress() {
    try {
      analytics.event('contact_breeder_click', {
        breeder_affiliation: breeder.affiliation,
        contact_source: 'breeder_profile',
        logged_in: Boolean(user),
      });
    } catch {
      // Tracking must not block opening the contact flow.
    }

    return router.push(route('breeders.contact', { breeder: breeder.slug }));
  }

  return (
    <Button
      text={text ?? t('contact_breeder_button.contact_breeder', { breeder: breeder.name })}
      icon={falCommentLines}
      iconPosition={'left'}
      color={'primary'}
      center={true}
      className={buttonClassName}
      textClassName={textClassName}
      onPress={onPress}
      testID="contact-breeder"
    />
  );
};

export default ContactBreederButton;
